div
<template>
    <main>
        <div overflow-hidden h-full>
            <n-layout position="absolute" style="top: 0; bottom: 0">
                <!-- 顶层 -->
                <!-- style="background-color: #f7f9fa;" -->
                <n-layout-header v-if="showMenu" z-2 w-full h-20 p-1 style="background-color: #f8f9fb;">
                    <n-grid x-gap="13" h-full>
                        <n-gi span="2" style="min-width: 150px;z-index: 9998;" text-white>
                            <n-space align="center" text-center h-full>
                                <n-image style="height: 62px; aspect-ratio: 1/1" :src="infoLogo" />
                                <span text-black text-1.5xl>INFO</span>
                            </n-space>
                        </n-gi>
                        <n-gi span="14" text-left>
                            <!-- 横向菜单 -->
                            <n-space align="center" justify="center" pr-2 h-full style="margin-left: 10px;">
                                <div v-if="showMenu && isTopMen">
                                    <TopMenu
                                        :default-value="selectedMenu" :options="menuOptionsSubTop"
                                        @update:value="handleUpdateValueRouter"
                                    />
                                </div>
                            </n-space>
                        </n-gi>
                        <n-gi span="8" h-full>
                            <n-space align="center" justify="end" pr-2 h-full>
                                <n-dropdown trigger="click" :options="organizationList" @select="handleOrganization">
                                    <n-button text-black>
                                        {{ deptCodeSelect ? deptCodeSelect : 'ORZ' }}
                                    </n-button>
                                </n-dropdown>
                                <n-icon
                                    v-permission="['info:home:switch']" size="24" cursor-pointer text-black
                                    @click="switchMenuFun(isTopMen)"
                                >
                                    <ArrowsHorizontal />
                                </n-icon>
                                <n-dropdown
                                    placement="bottom-start" trigger="click" size="small" :options="options"
                                    @select="handleSelect"
                                >
                                    <n-button flex quaternary text-black>
                                        <n-icon size="24">
                                            <i-carbon-language />
                                        </n-icon>
                                        <n-text text-black ml-2>
                                            {{ nameMapRef.get(locale) }}
                                        </n-text>
                                    </n-button>
                                </n-dropdown>
                                <user-profile-menu />
                            </n-space>
                        </n-gi>
                    </n-grid>
                </n-layout-header>
                <div relative flex flex-row overflow-hidden w-full>
                    <!-- 左侧菜单栏 -->
                    <!-- <n-layout> -->
                    <n-layout-sider
                        v-if="showMenu && !isTopMen" class="render-sub-left-menu" :bordered="false" inverted
                        content-style="padding: 4px 0px; overflow-y: auto; height: calc(100vh - 5rem);background-color: #f8f9fb;"
                        collapse-mode="width" :collapsed-width="64" :collapsed="subCollapsed" :width="240"
                        :theme-overrides="layoutSiderThemeOverrides" @collapse="subCollapsed = true"
                        @expand="subCollapsed = false"
                    >
                        <n-menu
                            :ref="(vm) => setMenu(vm)" class="render-sub-left-menu" :default-value="selectedMenu"
                            label-field="name" inverted :indent="24" :watch-props="['defaultValue']"
                            :options="menuOptionsSubLeft" :render-label="renderSubLabel"
                            @update:value="handleUpdateValue"
                        />
                    </n-layout-sider>
                    <!-- </n-layout> -->
                    <!-- 路由页面 -->
                    <n-layout
                        relative
                        content-style="display:flex;flex-direction:column;overflow-y: auto; height: calc(100vh - 5rem);"
                        class="container-bg"
                    >
                        <n-card class="container-bg" :bordered="false" content-style="padding:.5rem" h-full>
                            <router-view v-slot="{ Component }">
                                <keep-alive :include="['ServiceCpvContainer', ...cachedRouteList]">
                                    <component :is="Component" />
                                </keep-alive>
                            </router-view>
                            <MicroContainer />
                            <IframeContainer />
                            <IframeIMContainer />
                            <IframeVINContainer />
                            <IframeAIContainer />
                        </n-card>
                    </n-layout>
                    <!-- 脚部 -->
                    <n-layout-footer v-if="showFooter" position="absolute" bordered h-12 p-3 text-center>
                        {{ `@${$t('license.powered_by')}` }}
                    </n-layout-footer>
                </div>
            </n-layout>
        </div>

        <n-modal
            v-model:show="dialogVisible" style="max-width: 500px" :title="dialogTitle" v-bind="events"
            preset="card"
        >
            <RouteSearch />
        </n-modal>
    </main>
    <!-- <ChangePsw
        :show="showChangePsw" :pwd-remind-day="pwdRemindDays" :login-flag="loginFlag"
        :style="{ 'z-index': 9999999999 }" @update:close="showChangePsw = false"
    /> -->

    <n-modal
        v-model:show="dialogVisibleEnglish" :title="dialogTitleEnglish" style="height: 500px" preset="card"
        v-bind="eventsEnglish" w="8/10"
    >
        <EnglishExport />
    </n-modal>
</template>

<script lang="ts">
import type { Ref } from 'vue';
import type { MenuGroupOption, MenuOption, NMenu } from 'naive-ui';
import { NEllipsis, NIcon, NTooltip } from 'naive-ui';
import { RouterLink } from 'vue-router';
import { useUserStore } from '../stores/user';
import { routerSearchName, useRouteSearchDialog } from './default-modules/routeSearchDialog';
import RouteSearch from './default-modules/routeSearch.vue';
import { getIcon } from './default-modules/icon';
import { useEnglishExportDialog } from './englishDialog';
import EnglishExport from './english-export-Dialog/english-export-dialog.vue';
import topMenu from './topMenu.vue';
import { commonRequests } from '~/requests/common/common.request';
import { useCommonStore } from '~/stores/common';
import { AuthFailedType, navigationGuard } from '~/utils/navigationGuard';
import type { NavDataOrigin } from '~/utils/router';
import {
    RouteType,
    formatRoutes,
    formatRoutesLeft,
    formatRoutesTop,
    routeMap,
} from '~/utils/router';
import { resHandler } from '~/utils/http/handler';
import { functionRefWrapper } from '~/utils/helper';
import Search from '~icons/carbon/search';
import infoLogo from '~/assets/info-logo.png';

import { layoutSiderThemeOverrides, tabStyle } from '~/layouts/default-modules/theme';
import logo from '~/assets/logo.png';
import { useAuthToken } from '~/utils/token';
import arrowsHorizontal from '~icons/carbon/arrows-horizontal';

const fallbackHomePage = import.meta.env.VITE_HOMEPAGE_FALLBACK;
export default defineComponent({
    components: {
        RouteSearch,
        EnglishExport,
        ArrowsHorizontal: arrowsHorizontal,
        TopMenu: topMenu,
        Search,
    },
    beforeRouteEnter(to, from, next) {
        navigationGuard<NavDataOrigin[]>(to, from, next, {
            onSourceFetch: async () => {
                const { getUserInfo } = useUserStore();
                const { infoHomeMsg } = useAuthToken();
                await getUserInfo();
                const res = await commonRequests.getRoutes(null);
                const isSuccess = await resHandler(res, {});
                if (!isSuccess) throw new Error('route fetch failed');
                if (isSuccess) {
                    infoHomeMsg.value = [];
                    res.res?.[0]?.children?.forEach((i, e) => {
                        i.children?.forEach((a, b) => {
                            if (a.dataType) {
                                infoHomeMsg.value.push(a.dataType);
                            }
                        });
                    });
                    infoHomeMsg.value = [...new Set(infoHomeMsg.value)];
                }
                return res.res as NavDataOrigin[];
            },
            sourceFormatter: async (source) => {
                routeMap.clear();
                return formatRoutes(source);
            },
            sourceFormatterTop: async (source) => {
                return formatRoutesTop(source, '2');
            },
            sourceFormatterLeft: async (source) => {
                return formatRoutesLeft(source, '1');
            },
            routerAuth: async (to) => {
                const commonStore = useCommonStore();
                const userStore = useUserStore();
                commonStore.currentRouteKey = to.path;
                const validateRes = routeMap.has(commonStore.currentRouteKey);

                function endsWith(str, suffix) {
                    return str.includes(suffix, str.length - suffix.length);
                }

                if (commonStore.currentRouteKey === '/Information/Homepage' ||
                    endsWith(commonStore.currentRouteKey, 'Review')) {
                    userStore.switchMenu(true);
                }

                console.log(
                    'route auth result:',
                    validateRes,
                    '\npath:',
                    commonStore.currentRouteKey,
                );
                return validateRes;
            },
            onAuthFailed: (type) => {
                if (type === AuthFailedType.Route) {
                    next('/403');
                }
                if (type === AuthFailedType.Session) {
                    if (['development', 'theme', 'test'].includes(import.meta.env.MODE))
                        next('/auth/login');
                    else {
                        const { isLogout } = useUserStore();
                        if (isLogout) {
                            window.location.replace(import.meta.env.VITE_IDP_LOGOUT_URL);
                        } else {
                            next({
                                path: '/auth/oauth',
                                query: {
                                    from: encodeURIComponent(to.fullPath),
                                },
                            });
                        }
                    }
                }
            },
            onAuthSuccess: async () => {
                const commonStore = useCommonStore();
                if (to.path !== commonStore.currentRouteKey) {
                    next({ path: commonStore.currentRouteKey, query: to.query }); // 跳转到改写后的路径
                } else {
                    next(); // 正常导航
                }
            },
            excludeRoutes: ['/homepage/empty', '/homepage/homepage', '/403', '/404'],
        });
    },
    setup() {
        const isDev = import.meta.env.MODE === 'development';
        const globalLanguage = useGlobalLanguage();
        const commonStore = useCommonStore();
        const uerStore = useUserStore();
        const router = useRouter();
        const { cachedRouteList } = storeToRefs(commonStore);
        const { homepage } = useHomePage();
        const { brand, infoHomeMsg, sysKey } = useAuthToken();
        const organizationList = ref<any>([]);
        const deptCodeSelect = ref<number>();
        const searchValue = ref<string>('');
        const showPopover = ref<boolean>(false);
        const waterInfo = ref<any>({
            username: 'SMIL',
            realName: 'SMIL',
        });
        if (uerStore?.userInfo) {
            waterInfo.value.username = uerStore?.userInfo?.username;
            waterInfo.value.realName = uerStore?.userInfo?.realName;
        }
        if (!brand.value) {
            router.push('/auth/login');
        }

        const uploadFileListLength = computed(() => uerStore.uploadList.length);

        const { suffixList, addPageButton } = useTabSuffix();

        const showFooter = ref(false);

        const { dialogVisible, dialogTitle, events, open } = useRouteSearchDialog();
        useEventListener(window, 'keyup', (e) => {
            if (e.key === '/' && e.ctrlKey) {
                open();
            }
        });
        const menuOptions = computed(() => commonStore.formattedRoutes);
        const menuOptionsTop = computed(() => commonStore.formattedRoutesTop);
        const menuOptionsLeft = computed(() => commonStore.formattedRoutesLeft);
        const menuOptionsMap = computed(() => {
            const map = new Map<string, MenuOption[]>();
            menuOptions.value.forEach((i) => {
                map.set(i.key as string, i.children as MenuOption[]);
            });
            return map;
        });
        const menuOptionsMapTop = computed(() => {
            const map = new Map<string, MenuOption[]>();
            menuOptionsTop.value.forEach((i) => {
                map.set(i.key as string, i.children as MenuOption[]);
            });
            return map;
        });

        const menuOptionsMapLeft = computed(() => {
            const map = new Map<string, MenuOption[]>();
            menuOptionsLeft.value.forEach((i) => {
                map.set(i.key as string, i.children as MenuOption[]);
            });
            return map;
        });
        const menuOptionsMain = computed(() =>
            (menuOptions as Ref<MenuOption[]>).value.map((i) => {
                const res = { ...i };
                delete res.children;
                return res;
            }),
        );
        const mainSelected = ref(
            routeMap.get(commonStore.currentRouteKey)?.rootKey ??
            menuOptionsMain.value[0]?.key ??
            '',
        );
        const selectedMenu = computed(() => commonStore.currentRouteKey ?? '');
        const mainCollapsed = ref(false);
        const subCollapsed = ref(false);
        const menu = ref<InstanceType<typeof NMenu> | null>(null);
        const setMenu = functionRefWrapper(menu);
        const handleUpdateValueRouter = (key: string, item: MenuOption, value: string) => {
            const option = item as NavDataOrigin;
            commonStore.currentRouteKey = key;
            router.push({ path: key, query: value ? { id: value } : {} });
        };
        const handleUpdateValue = (key: string, item: MenuOption) => {
            const option = item as NavDataOrigin;
            commonStore.currentRouteKey = key;
        };

        const renderMainLabel = (item: MenuOption | MenuGroupOption) => {
            const option = item as NavDataOrigin;
            return h(
                NTooltip,
                { placement: 'right' },
                {
                    default: () => option.meta?.title ?? option.label,
                    trigger: () =>
                        h('div', { class: 'menu-icon-container' }, [
                            h(
                                'div',
                                { class: 'menu-div' },
                                h(NIcon, {
                                    color: 'white',
                                    component: getIcon(option.meta?.icon),
                                    size: 24,
                                }),
                            ),
                            // h('div', { class: 'menu-div' }, option.meta?.title ?? option.label),
                        ]),
                },
            );
        };

        const renderSubLabel = (item: MenuOption | MenuGroupOption) => {
            const option = item as NavDataOrigin;
            if (option.children) {
                return h('div', {}, h(NEllipsis, {}, { default: () => option.meta?.title }));
            }
            if (option.component === RouteType.InnerLink) {
                return h('a', { target: '_blank', href: option.path }, option.meta?.title);
            }
            return h(
                NEllipsis,
                {
                    tooltip: {
                        placement: 'right',
                    },
                },
                {
                    default: () =>
                        h(
                            RouterLink,
                            {
                                to: option.path ?? '',
                            },
                            () => option.meta?.title,
                        ),
                    tooltip: () => option.meta?.title,
                },
            );
        };

        const renderSubIcon = (item: MenuOption) => {
            const option = item as NavDataOrigin;
            if (option.meta?.icon)
                return h(NIcon, {
                    component: getIcon(option.meta.icon),
                    style: {
                        marginLeft: subCollapsed.value ? '8px' : '0',
                    },
                });
            return undefined;
        };

        watch(cachedRouteList, (val) => {
            console.log('cachedRouteList', val);
        });

        watch(selectedMenu, (val) => {
            menu.value?.showOption(val);
        });

        addPageButton({
            name: routerSearchName,
            renderIcon: () =>
                h(
                    NIcon,
                    {},
                    {
                        default: () => h(Search),
                    },
                ),
            onClick: () => {
                dialogVisible.value = true;
            },
            toolTipContent: () => dialogTitle.value,
            detached: true,
        });
        const getOrganizationList = async () => {
            const res: any = await commonRequests.getOtherDeptList();
            const isSuccess = await resHandler(res, {});
            if (!isSuccess) throw new Error('route fetch failed');
            organizationList.value = res.res.map((e) => {
                if (e.selected === 1) {
                    deptCodeSelect.value = e.deptCode;
                }
                return {
                    label: e.deptCode,
                    key: e.deptCode,
                };
            });
        };
        // const showChangePsw = ref(false);
        // const pwdRemindDays = ref<string>('');
        // const loginFlag = ref<string>('');
        onMounted(() => {
            // const onlyStr = window.sessionStorage.getItem('onlyStr');
            // if (!onlyStr) {
            //     if (uerStore.userInfo?.pwdRemindDay) {
            //         pwdRemindDays.value = uerStore.userInfo.pwdRemindDay;
            //         if (Number(pwdRemindDays.value) <= 0) {
            //             showChangePsw.value = true;
            //         } else {
            //             window.sessionStorage.setItem('onlyStr', '1');
            //             showChangePsw.value = true;
            //         }
            //     }
            //     if (uerStore.userInfo?.loginFlag) {
            //         loginFlag.value = uerStore.userInfo.loginFlag;
            //     }
            // }
            getOrganizationList();
            const myButton: any = document.getElementById('app');
            // 给该元素添加点击事件
            myButton.addEventListener('click', (event) => {
                event.stopPropagation();
                showPopover.value = false;
            });
        });

        // 英文下载
        const {
            dialogVisible: dialogVisibleEnglish,
            dialogTitle: dialogTitleEnglish,
            open: openEnglish,
            events: eventsEnglish,
        } = useEnglishExportDialog();

        const showEngList = () => {
            dialogVisibleEnglish.value = true;
        };
        const handleOrganization = async (key: number) => {
            deptCodeSelect.value = key;
            const res: any = await commonRequests.switchDept(key);
            const isSuccess = await resHandler(res, {});
            if (!isSuccess) throw new Error('route fetch failed');
            await router.push('/Information/Homepage');
            window.location.reload();
        };
        const switchMenuFun = (e) => {
            const flag = !e;
            if (flag) {
                router.replace('/Information/Homepage');
            } else {
                // router.replace('/homepage/empty');
                router.replace('/Information/system/searchAnnouncements');
            }
            uerStore.switchMenu(flag);
        };
        const isTopMen = computed(() => uerStore.isTopMen);
        const searchTo = (e) => {
            router.push({ path: '/Information/Search', query: { key: searchValue.value } });
            showPopover.value = false;
            uerStore.switchMenu(true);
        };
        return {
            switchMenuFun,
            isDev,
            showFooter,
            menuOptionsMain,
            isTopMen,
            menuOptionsSub: computed(
                () => menuOptionsMap.value.get(mainSelected.value as string) ?? [],
            ),
            menuOptionsSubTop: computed(
                () => menuOptionsMapTop.value.get(mainSelected.value as string) ?? [],
            ),
            menuOptionsSubLeft: computed(
                () => menuOptionsMapLeft.value.get(mainSelected.value as string) ?? [],
            ),
            handleUpdateValue,
            ...globalLanguage,
            renderSubLabel,
            renderSubIcon,
            renderMainLabel,
            mainSelected,
            selectedMenu,
            menu,
            setMenu,
            mainCollapsed,
            subCollapsed,
            cachedRouteList,
            showMenu: computed(() => commonStore.showMenu),
            layoutSiderThemeOverrides,
            tabStyle,
            dialogVisible,
            dialogTitle,
            events,
            suffixList,
            uploadFileListLength,
            logo,
            brand,
            showEngList,
            dialogVisibleEnglish,
            dialogTitleEnglish,
            openEnglish,
            eventsEnglish,
            waterInfo,
            handleUpdateValueRouter,
            handleOrganization,
            organizationList,
            deptCodeSelect,
            searchTo,
            searchValue,
            showPopover,
            infoLogo,
        };
    },
});
</script>

<style>
.container-bg {
    background-color: #fff !important;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-active {
    opacity: 0;
}

:deep(.menu-icon-container) {
    padding: 8px 1.5px;
    text-align: center;
    width: 100%;
}

:deep(.menu-div) {
    font-size: 13px;
    /* height: 20px; */
    margin-top: 8px;
}
</style>